import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store';

Vue.use(Router);

const router = new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	linkActiveClass: 'active',
	routes: [{
			path: '*',
			redirect: {
				path: '/404'
			}
		},
		{
			path: '/',
			redirect: {
				path: '/home'
			}
		},
		{
			path: '/home',
			name: 'Home',
			component: () => import(
				`@/views/Home.vue`
			),
			meta: {
				requiresHome: true
			}
		},
		{
			path: '/test',
			name: 'Test',
			component: () => import(
				`@/views/Test`
			),
			meta: {
				requiresGuard: true
			}
		},
		{
			path: '/404',
			name: '404',
			component: () => import(
				`@/views/NotFound`
			),
			meta: {
				requiresHome: true
			}
		}
	],

	scrollBehavior(to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition
		}
		if (to.hash) {
			return {
				selector: to.hash
			}
		}
		return {
			x: 0,
			y: 0
		}
	}
})

router.beforeEach((to, from, next) => {
	if (to.matched.some(record => record.meta.requiresGuard)) {
		if (!store.getters.isGuardHome) {
			next('/home')
		} else {
			next()
		}
	} else if (to.matched.some(record => record.meta.requiresHome)) {
		if (store.getters.isGuardHome) {
			next('/test')
		} else {
			next()
		}
	} else {
		next()
	}
})

export default router;